import { WidgetSchema } from 'features/views/LayoutEditor/types'

import { GalleryWidget } from './GalleryWidget'
import { GalleryWidgetAdminControls } from './GalleryWidgetAdminControls'
import { GalleryWidgetType } from './types'

export const GalleryWidgetMeta: WidgetSchema<GalleryWidgetType> = {
    category: 'data',
    label: 'Gallery',
    icon: 'Image',
    component: GalleryWidget,
    adminControlsComponent: GalleryWidgetAdminControls,
    defaultAttrs: {
        style: 'single',
        aspectRatio: '3:1',
        allowFullImagePreview: false,
        images: [],
    },
    requireFields: (attrs) => {
        const requiredFields = new Set<string>()

        const { images } = attrs
        for (const image of images) {
            if (image?.type === 'field' && !!image.fieldApiName) {
                requiredFields.add(image.fieldApiName)
            }
        }

        return Array.from(requiredFields)
    },
}
